import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useSportsPromotion } from '@/features/sports/composables/useSportsPromotion';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { trackClickOutSports } from '@/helpers/offer-helper';
import { SingleStepSportEvent, SportObjectType } from '@/@types/graphql-types';
import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { SingleStepContext } from '@/features/sports/helpers/config';
import { useI18n } from '@/helpers/composables/useI18n';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useAppStore, useLanguageStore } from '@/helpers/composables/useStores';
import { faPlay } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'EventBackdropPromo',
  props: {
    context: null,
    event: null
  },
  setup(__props: any) {

const props = __props as {
	context: SingleStepContext;
	event: SingleStepSportEvent;
};



const { tc } = useI18n();

const { country } = useLanguageStore();
const { sportsPromotions } = useSportsPromotion();
const { xServeTrack } = useAppStore();

const sportContext = computed(() =>
	SnowplowSportContext.fromSportEventV2(props.context.sportType, props.context.pageType, props.event)
);

const displayedSportsPromotion = computed(() => {
	const byEventId =
		sportsPromotions.value?.promotions.find(promotion => promotion?.eventIds?.includes(props.event.id)) ?? null;

	const eventOffers = new Set(props.event.offers.map(offer => offer.package.shortName));
	const byPackageShortName =
		sportsPromotions.value.promotions.find(promo => eventOffers.has(promo.package.shortName)) ?? null;

	return byEventId ?? byPackageShortName;
});

const title = computed(() => displayedSportsPromotion.value?.title ?? tc('WEBAPP_WATCHNOW'));

const subtitle = computed(() => displayedSportsPromotion.value?.subtitle ?? null);

const clickoutUrl = computed(() =>
	// NOTE - 26.11.25 - removing skip UCT2 for all instances. There is no live sports promo, so no impact, and no way to test future cases
	// If one arises, we can revisit then. Jack is aware.
	// this was for ESPN Disney+ sports bundle promo
	new ClickoutUrl(displayedSportsPromotion.value)
		.set('uct_country', country.value)
		.addContexts(sportContext)
		.setCanary(xServeTrack.value)
);

function handlePromoClick() {
	if (!displayedSportsPromotion.value) return;

	trackClickOutSports(displayedSportsPromotion.value, undefined, 0, SportObjectType.MainEvent, 'backdrop', [
		sportContext.value,
	]);
}

return { __sfc: true,props, tc, country, sportsPromotions, xServeTrack, sportContext, displayedSportsPromotion, title, subtitle, clickoutUrl, handlePromoClick, FontAwesomeIcon, ProviderIcon, faPlay }
}

})